module.exports = __webpack_public_path__ + "static/testimonials-1-828e0935e45611b23593d139bd1984f1.jpg";